import { Button } from 'components/Button';
import { Surface } from 'components/Surface';
import { useTypeSafeTranslation } from 'hooks';
import { Trans } from 'next-i18next';
import Link from 'next/link';
import React, { FC } from 'react';
import { routes } from 'types/routes';
import styles from './Body.module.less';

const Body: FC = () => {
  const { t } = useTypeSafeTranslation();
  return (
    <>
      <div className={styles.root}>
        <img id="campaign" src="/images/campaign/object.png" alt="object" />

        <h2>ORBS Staking Reward</h2>
        <p>
          APY* Staking Rewards: <b>Industry-leading</b>
        </p>

        <img className={styles.angleLeft} src="/images/campaign/polygon_blur.png" alt="decor" />
        <img className={styles.angleRight} src="/images/campaign/polygon_blur.png" alt="decor" />
      </div>
      <div className={styles.stakeCard}>
        <p>Stake</p>
        <Surface className={styles.cardBody} borderMd filled>
          <b>ORBS</b>
          <div className="f-between">
            <div>
              <p className="text-12 secondary mb-8 thin">Est. APY</p>
              <div style={{ background: '#556195' }} className={styles.apr}>
                6.67%
              </div>
            </div>
            <div>
              <p className="text-12 secondary mb-8 thin">Top 10 APY</p>
              <div className={styles.apr}>8.5%</div>
            </div>
          </div>
          <div className="f-center f-column">
            <Link href={routes.stake}>
              <a>
                <Button>Stake Now</Button>
              </a>
            </Link>

            <p className="secondary mb-8 thin">industry-leading</p>
          </div>
        </Surface>
      </div>
    </>
  );
};

export default Body;
